export const createGetAllInfluencersByCategoryIdRequest = (category_id) => {
  return {
    url: `/influencers?category_id=${category_id}`,
    method: "GET",
  };
};

export const createGetAllCategoriesRequest = () => {
  return {
    url: "/influencers/categories",
    method: "GET",
  };
};

export const createGetAllPostsByInfluencerIdRequest = (influencer_id) => {
  return {
    url: `/influencers/${influencer_id}/posts`,
    method: "GET",
  };
};

export const createGetPostsByCategoryRequest = (
  category_id,
  per_page,
  page
) => {
  return {
    url: `/influencers/categories/${category_id}/posts?per_page=${per_page}&page=${page}`,
    method: "GET",
  };
};
